import { inject, Injectable } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  CanActivateChild,
  GuardResult,
  MaybeAsync,
  Router,
} from '@angular/router';
import { EytcAuthService } from '@services/authentication/eytc-auth.service';
import { map, Observable } from 'rxjs';
import { FULL_HOME_ROUTE } from '@routes';

@Injectable({
  providedIn: 'root',
})
export class RoleGuard implements CanActivate, CanActivateChild {
  #authService = inject(EytcAuthService);
  #router = inject(Router);
  #userRoles$ = toObservable(this.#authService.userRoles);

  canActivate(route: ActivatedRouteSnapshot): Observable<GuardResult> {
    return this.#userRoles$.pipe(
      map(currentRoles => {
        const requiredRoles = route.data['roles'] ?? [];
        if ((requiredRoles as number[]).some((role: number) => currentRoles.includes(role))) {
          return true;
        }
        console.warn("User doesn't have the required roles");
        void this.#router.navigate([FULL_HOME_ROUTE]);
        return false;
      })
    );
  }

  canActivateChild(childRoute: ActivatedRouteSnapshot): MaybeAsync<GuardResult> {
    return this.canActivate(childRoute);
  }
}
